import { DeviceColumnTypes } from "pages/Devices/devices.config";
import { COLUMN_TYPE } from "utils/constants";
import { formatPhoneNumber } from "utils/util-functions";

export interface DeviceDataTypes {
  devicePool: string;
  imei: string;
  orgGroup: string;
  serialNumber: string;
  userName: string;
  PhoneNumber?: string;
  locationTrailEnabled?: boolean;
  lastCheckInTime?: string;
  softwareVersion?: string;
  online?: boolean;
}

export const DEVICE_LOOKUP_COLUMNS: DeviceColumnTypes[] = [
  {
    id: "serialNumber",
    label: "Serial Number",
    filter: true,
    isSort: true,
    type: COLUMN_TYPE.STRING,
  },
  {
    id: "imei",
    label: "IMEI",
    filter: true,
    isSort: true,
    type: COLUMN_TYPE.STRING,
  },
  {
    id: "orgGroup",
    label: "Organization Name",
    filter: true,
    isSort: true,
    type: COLUMN_TYPE.STRING,
  },
  {
    id: "userName",
    label: "User Name",
    filter: true,
    isSort: true,
    type: COLUMN_TYPE.STRING,
  },
  {
    id: "devicePool",
    label: "Device Pool",
    filter: true,
    isSort: true,
    type: COLUMN_TYPE.STRING,
  },
  {
    id: "PhoneNumber",
    label: "Sim Phone No.",
    format: (value: any) => formatPhoneNumber(value || ""),
    filter: true,
    isSort: true,
    type: COLUMN_TYPE.STRING,
  },
  {
    id: "locationTrailEnabled",
    label: "Location Trail Enabled",
    filter: true,
    isSort: true,
    type: COLUMN_TYPE.STRING,
  },
  {
    id: "lastCheckInTime",
    label: "Last Check-In",
    filter: true,
    isSort: true,
    type: COLUMN_TYPE.STRING,
  },
  {
    id: "softwareVersion",
    label: "Software Version",
    filter: true,
    isSort: true,
    type: COLUMN_TYPE.STRING,
  },
];

export const ORGANIZATION_DEVICE_LOOKUP_COLUMNS: DeviceColumnTypes[] = [
  DEVICE_LOOKUP_COLUMNS[0],
  { id: "online", label: "Status", type: COLUMN_TYPE.STRING },
  ...DEVICE_LOOKUP_COLUMNS.slice(1),
];

export const DEVICE_LOOKUP_OPTIONS: DeviceColumnTypes[] = [
  {
    id: "serialNumber",
    label: "Serial Number",
    filter: true,
    isSort: true,
    type: COLUMN_TYPE.STRING,
  },
  {
    id: "imei",
    label: "IMEI",
    filter: true,
    isSort: true,
    type: COLUMN_TYPE.STRING,
  },
  {
    id: "orgGroup",
    label: "Organization Name",
    filter: true,
    type: COLUMN_TYPE.STRING,
  },
];
